import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/tailwind.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Modal from 'react-modal'; // Import react-modal

Modal.setAppElement('#root'); // Set the app element here

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn mor	e: https://bit.ly/CRA-vitals
reportWebVitals();
